(function() {
    "use strict";
    
    // Top countries that should always stay at the top
    var topCountries = ["CH", "DE", "US"];
    
    // Country names in different languages
    var countryTranslations = {
        'de': {
            'AM': 'Armenien', 'AU': 'Australien', 'AT': 'Österreich', 'BH': 'Bahrain',
            'BE': 'Belgien', 'BA': 'Bosnien und Herzegowina', 'BR': 'Brasilien',
            'BG': 'Bulgarien', 'CN': 'China', 'DE': 'Deutschland', 'DK': 'Dänemark',
            'EE': 'Estland', 'FI': 'Finnland', 'FR': 'Frankreich', 'FO': 'Färöer',
            'GI': 'Gibraltar', 'GR': 'Griechenland', 'GL': 'Grönland', 'GG': 'Guernsey',
            'IN': 'Indien', 'IQ': 'Irak', 'IE': 'Irland', 'IS': 'Island',
            'IM': 'Isle of Man', 'IL': 'Israel', 'IT': 'Italien', 'JP': 'Japan',
            'JE': 'Jersey', 'JO': 'Jordanien', 'CA': 'Kanada', 'QA': 'Katar',
            'HR': 'Kroatien', 'KW': 'Kuwait', 'LV': 'Lettland', 'LB': 'Libanon',
            'LI': 'Liechtenstein', 'LT': 'Litauen', 'LU': 'Luxemburg', 'MV': 'Malediven',
            'MT': 'Malta', 'MX': 'Mexiko', 'MC': 'Monaco', 'ME': 'Montenegro',
            'NZ': 'Neuseeland', 'NL': 'Niederlande', 'NO': 'Norwegen', 'OM': 'Oman',
            'PK': 'Pakistan', 'PL': 'Polen', 'PT': 'Portugal', 'RO': 'Rumänien',
            'SM': 'San Marino', 'SA': 'Saudi-Arabien', 'SE': 'Schweden', 'CH': 'Schweiz',
            'RS': 'Serbien', 'SG': 'Singapur', 'SK': 'Slowakei', 'SI': 'Slowenien',
            'HK': 'Sonderverwaltungsregion Hongkong', 'MO': 'Sonderverwaltungsregion Macau',
            'ES': 'Spanien', 'ZA': 'Südafrika', 'KR': 'Südkorea', 'TW': 'Taiwan',
            'TH': 'Thailand', 'CZ': 'Tschechien', 'TR': 'Türkei', 'HU': 'Ungarn',
            'VA': 'Vatikanstadt', 'AE': 'Vereinigte Arabische Emirate',
            'US': 'Vereinigte Staaten', 'GB': 'Vereinigtes Königreich', 'CY': 'Zypern',
            'EG': 'Ägypten'
        },
        'en': {
            'AM': 'Armenia', 'AU': 'Australia', 'AT': 'Austria', 'BH': 'Bahrain',
            'BE': 'Belgium', 'BA': 'Bosnia and Herzegovina', 'BR': 'Brazil',
            'BG': 'Bulgaria', 'CN': 'China', 'DE': 'Germany', 'DK': 'Denmark',
            'EE': 'Estonia', 'FI': 'Finland', 'FR': 'France', 'FO': 'Faroe Islands',
            'GI': 'Gibraltar', 'GR': 'Greece', 'GL': 'Greenland', 'GG': 'Guernsey',
            'IN': 'India', 'IQ': 'Iraq', 'IE': 'Ireland', 'IS': 'Iceland',
            'IM': 'Isle of Man', 'IL': 'Israel', 'IT': 'Italy', 'JP': 'Japan',
            'JE': 'Jersey', 'JO': 'Jordan', 'CA': 'Canada', 'QA': 'Qatar',
            'HR': 'Croatia', 'KW': 'Kuwait', 'LV': 'Latvia', 'LB': 'Lebanon',
            'LI': 'Liechtenstein', 'LT': 'Lithuania', 'LU': 'Luxembourg', 'MV': 'Maldives',
            'MT': 'Malta', 'MX': 'Mexico', 'MC': 'Monaco', 'ME': 'Montenegro',
            'NZ': 'New Zealand', 'NL': 'Netherlands', 'NO': 'Norway', 'OM': 'Oman',
            'PK': 'Pakistan', 'PL': 'Poland', 'PT': 'Portugal', 'RO': 'Romania',
            'SM': 'San Marino', 'SA': 'Saudi Arabia', 'SE': 'Sweden', 'CH': 'Switzerland',
            'RS': 'Serbia', 'SG': 'Singapore', 'SK': 'Slovakia', 'SI': 'Slovenia',
            'HK': 'Hong Kong SAR', 'MO': 'Macao SAR',
            'ES': 'Spain', 'ZA': 'South Africa', 'KR': 'South Korea', 'TW': 'Taiwan',
            'TH': 'Thailand', 'CZ': 'Czech Republic', 'TR': 'Turkey', 'HU': 'Hungary',
            'VA': 'Vatican City', 'AE': 'United Arab Emirates',
            'US': 'United States', 'GB': 'United Kingdom', 'CY': 'Cyprus',
            'EG': 'Egypt'
        },
        'fr': {
            'AM': 'Arménie', 'AU': 'Australie', 'AT': 'Autriche', 'BH': 'Bahreïn',
            'BE': 'Belgique', 'BA': 'Bosnie-Herzégovine', 'BR': 'Brésil',
            'BG': 'Bulgarie', 'CN': 'Chine', 'DE': 'Allemagne', 'DK': 'Danemark',
            'EE': 'Estonie', 'FI': 'Finlande', 'FR': 'France', 'FO': 'Îles Féroé',
            'GI': 'Gibraltar', 'GR': 'Grèce', 'GL': 'Groenland', 'GG': 'Guernesey',
            'IN': 'Inde', 'IQ': 'Irak', 'IE': 'Irlande', 'IS': 'Islande',
            'IM': 'Île de Man', 'IL': 'Israël', 'IT': 'Italie', 'JP': 'Japon',
            'JE': 'Jersey', 'JO': 'Jordanie', 'CA': 'Canada', 'QA': 'Qatar',
            'HR': 'Croatie', 'KW': 'Koweït', 'LV': 'Lettonie', 'LB': 'Liban',
            'LI': 'Liechtenstein', 'LT': 'Lituanie', 'LU': 'Luxembourg', 'MV': 'Maldives',
            'MT': 'Malte', 'MX': 'Mexique', 'MC': 'Monaco', 'ME': 'Monténégro',
            'NZ': 'Nouvelle-Zélande', 'NL': 'Pays-Bas', 'NO': 'Norvège', 'OM': 'Oman',
            'PK': 'Pakistan', 'PL': 'Pologne', 'PT': 'Portugal', 'RO': 'Roumanie',
            'SM': 'Saint-Marin', 'SA': 'Arabie Saoudite', 'SE': 'Suède', 'CH': 'Suisse',
            'RS': 'Serbie', 'SG': 'Singapour', 'SK': 'Slovaquie', 'SI': 'Slovénie',
            'HK': 'Hong Kong RAS', 'MO': 'Macao RAS',
            'ES': 'Espagne', 'ZA': 'Afrique du Sud', 'KR': 'Corée du Sud', 'TW': 'Taïwan',
            'TH': 'Thaïlande', 'CZ': 'Tchéquie', 'TR': 'Turquie', 'HU': 'Hongrie',
            'VA': 'Vatican', 'AE': 'Émirats Arabes Unis',
            'US': 'États-Unis', 'GB': 'Royaume-Uni', 'CY': 'Chypre',
            'EG': 'Égypte'
        }
    };
    
    // UI translations
    var uiTranslations = {
        'de': {
            title: 'Willkommen bei ZIMMERLI',
            message: 'Bitte wählen Sie Land und Sprache.',
            button: 'Jetzt einkaufen',
            countryLabel: 'Land',
            languageLabel: 'Sprache'
        },
        'en': {
            title: 'Welcome to ZIMMERLI',
            message: 'Please select your country and language.',
            button: 'Shop now',
            countryLabel: 'Country',
            languageLabel: 'Language'
        },
        'fr': {
            title: 'Bienvenue chez ZIMMERLI',
            message: 'Veuillez sélectionner votre pays et langue.',
            button: 'Acheter maintenant',
            countryLabel: 'Pays',
            languageLabel: 'Langue'
        }
    };
    
    // Language names - always in NATIVE language
    var nativeLanguageNames = {
        'de': 'Deutsch',
        'en': 'English',
        'fr': 'Français'
    };
    
    var currentLang = 'de';
    var savedLang = null; // Store the user's selected language
    var savedCountry = null; // Store the user's selected country
    
    // Get current language from window.Shopify.locale
    function getShopifyLocale() {
        try {
            if (window.Shopify && window.Shopify.locale) {
                var locale = window.Shopify.locale;
                // Extract language code (e.g., "de" from "de-DE" or "de")
                if (locale.indexOf('-') > -1) {
                    return locale.split('-')[0].toLowerCase();
                }
                return locale.toLowerCase();
            }
        } catch (e) {
            console.log('Error getting Shopify locale:', e);
        }
        return null;
    }
    
    // Get current country from window.Shopify.country
    function getShopifyCountry() {
        try {
            if (window.Shopify && window.Shopify.country) {
                return window.Shopify.country.toUpperCase();
            }
        } catch (e) {
            console.log('Error getting Shopify country:', e);
        }
        return null;
    }
    
    // Detect language code from text
    function detectLangCode(text) {
        if (!text) return null;
        text = text.toLowerCase().trim();
        if (text === 'deutsch' || text === 'german' || text === 'allemand' || text === 'de') return 'de';
        if (text === 'english' || text === 'englisch' || text === 'anglais' || text === 'en') return 'en';
        if (text === 'français' || text === 'french' || text === 'französisch' || text === 'fr') return 'fr';
        return null;
    }
    
    // Get current language from select element
    function getCurrentLanguageFromSelect() {
        var langSelect = document.getElementById('blz_store_selector_selectlanguage');
        if (!langSelect) return null;
        
        var selectedOption = langSelect.options[langSelect.selectedIndex];
        if (selectedOption) {
            var lang = detectLangCode(selectedOption.textContent) || detectLangCode(selectedOption.value);
            return lang;
        }
        return null;
    }
    
    // Restore language selection
    function restoreLanguageSelection(langCode) {
        if (!langCode) return;
        var langSelect = document.getElementById('blz_store_selector_selectlanguage');
        if (!langSelect) return;
        
        // Find the option with matching language code
        var options = langSelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
            var opt = options[i];
            var optLang = detectLangCode(opt.textContent) || detectLangCode(opt.value);
            if (optLang === langCode) {
                langSelect.selectedIndex = i;
                break;
            }
        }
    }
    
    // Restore country selection
    function restoreCountrySelection(countryCode) {
        if (!countryCode) return;
        var countrySelect = document.getElementById('blz_store_selector_selectcountry');
        if (!countrySelect) return;
        
        // Try to set by value first
        if (countrySelect.querySelector('option[value="' + countryCode + '"]')) {
            countrySelect.value = countryCode;
            // Trigger change event to update flag
            var event = new Event('change', { bubbles: true });
            countrySelect.dispatchEvent(event);
            updateCountryFlag(countryCode);
            return;
        }
        
        // If not found, try to find by matching country code in options
        var options = countrySelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
            var opt = options[i];
            if (opt.value === countryCode) {
                countrySelect.selectedIndex = i;
                // Trigger change event to update flag
                var event = new Event('change', { bubbles: true });
                countrySelect.dispatchEvent(event);
                updateCountryFlag(countryCode);
                break;
            }
        }
    }
    
    // Update country flag image
    function updateCountryFlag(countryCode) {
        if (!countryCode) return;
        var flagImg = document.querySelector('.blz_store_selector_flag, .blz_storeSelector__select_country_flag img');
        if (flagImg) {
            // Convert country code to lowercase for flag URL
            var countryLower = countryCode.toLowerCase();
            flagImg.src = 'https://cdn.shopify.com/static/images/flags/' + countryLower + '.svg?width=32';
            flagImg.setAttribute('src', 'https://cdn.shopify.com/static/images/flags/' + countryLower + '.svg?width=32');
        }
    }
    
    // Set language options to native names (Deutsch, English, Français)
    function fixLanguageNames() {
        var langSelect = document.getElementById('blz_store_selector_selectlanguage');
        if (!langSelect) return;
        
        var options = langSelect.querySelectorAll('option');
        options.forEach(function(option) {
            var optLangCode = detectLangCode(option.textContent) || detectLangCode(option.value);
            if (optLangCode && nativeLanguageNames[optLangCode]) {
                if (option.textContent !== nativeLanguageNames[optLangCode]) {
                    option.textContent = nativeLanguageNames[optLangCode];
                }
            }
        });
    }
    
    // Update UI elements (title, message, button, labels)
    function updateUI(langCode) {
        var ui = uiTranslations[langCode];
        if (!ui) return;
        
        // Title
        var titleEl = document.querySelector('.blz_storeSelector__title');
        if (titleEl) {
            var titleInner = titleEl.querySelector('.blz_storeSelector__localization_resource_inputs');
            if (titleInner) {
                titleInner.textContent = ui.title;
            } else {
                titleEl.textContent = ui.title;
            }
        }
        
        // Message
        var messageEl = document.querySelector('.blz_storeSelector__message');
        if (messageEl) {
            var messageInner = messageEl.querySelector('.blz_storeSelector__localization_resource_inputs');
            if (messageInner) {
                messageInner.textContent = ui.message;
            } else {
                messageEl.textContent = ui.message;
            }
        }
        
        // Button
        var buttonEl = document.querySelector('.blz__storeSelector_confirm_cta');
        if (buttonEl) {
            buttonEl.textContent = ui.button;
        }
        
        // Country label
        var countryLabelEl = document.querySelector('.blz_storeSelector__select_country_label');
        if (countryLabelEl) {
            countryLabelEl.textContent = ui.countryLabel;
        }
        
        // Language label
        var languageLabelEl = document.querySelector('.blz_storeSelector__select_language_label');
        if (languageLabelEl) {
            languageLabelEl.textContent = ui.languageLabel;
        }
    }
    
    // Update country dropdown options
    function updateCountries(langCode) {
        var countrySelect = document.getElementById('blz_store_selector_selectcountry');
        if (!countrySelect) return;
        
        var translations = countryTranslations[langCode];
        if (!translations) return;
        
        var options = Array.prototype.slice.call(countrySelect.querySelectorAll('option'));
        var selectedValue = countrySelect.value;
        
        // Translate options
        options.forEach(function(option) {
            var code = option.value;
            if (code && translations[code]) {
                option.textContent = translations[code];
            }
        });
        
        // Sort: top countries first, then alphabetically
        var topOpts = [];
        var restOpts = [];
        
        options.forEach(function(opt) {
            var code = opt.value;
            if (topCountries.indexOf(code) !== -1) {
                topOpts.push(opt);
            } else if (code) {
                restOpts.push(opt);
            }
        });
        
        topOpts.sort(function(a, b) {
            return topCountries.indexOf(a.value) - topCountries.indexOf(b.value);
        });
        
        restOpts.sort(function(a, b) {
            return a.textContent.localeCompare(b.textContent, langCode);
        });
        
        countrySelect.innerHTML = '';
        topOpts.forEach(function(o) { countrySelect.appendChild(o); });
        
        // Add separator
        var separator = document.createElement('option');
        separator.value = '';
        separator.textContent = '----';
        separator.disabled = true;
        countrySelect.appendChild(separator);
        
        restOpts.forEach(function(o) { countrySelect.appendChild(o); });
        
        if (selectedValue) countrySelect.value = selectedValue;
        
        currentLang = langCode;
    }
    
    // ----- OS country list (ul.blz_os_country_list) - start here -----
    // Get country code from a list item (li) in the header/footer country list
    function getCountryCodeFromListItem(li) {
        if (!li) return null;
        var link = li.querySelector('a[href]');
        var href = link ? link.getAttribute('href') || '' : '';
        var dataCode = li.getAttribute('data-country') || (link && link.getAttribute('data-country'));
        if (dataCode) return dataCode.toUpperCase();
        var match = href.match(/country=([A-Z]{2})/i) || href.match(/markets\/([A-Z]{2})/i) || href.match(/\/([A-Z]{2})(?:\?|$|\/)/i);
        if (match) return match[1].toUpperCase();
        var text = (link ? link.textContent : li.textContent || '').trim();
        var bestCode = null;
        var bestLen = 0;
        for (var lang in countryTranslations) {
            var trans = countryTranslations[lang];
            for (var code in trans) {
                var name = trans[code];
                if (text === name || text.indexOf(name) === 0) {
                    if (name.length > bestLen) {
                        bestLen = name.length;
                        bestCode = code;
                    }
                } else if (text.indexOf(name) !== -1 && name.length > bestLen) {
                    bestLen = name.length;
                    bestCode = code;
                }
            }
        }
        return bestCode;
    }
    
    // Reorder the header/footer country list (ul.blz_os_country_list) so CH, DE, US appear first.
    // Only runs once per list (guarded) to avoid infinite loop with MutationObserver and unresponsive page.
    var reorderBlzInProgress = false;
    function reorderBlzOsCountryList() {
        if (reorderBlzInProgress) return;
        var list = document.querySelector('ul.blz_os_country_list');
        if (!list || list.getAttribute('data-blz-reordered') === '1') return;
        
        reorderBlzInProgress = true;
        try {
            var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li'));
            if (items.length === 0) return;
            
            var topItems = [];
            var restItems = [];
            
            items.forEach(function(li) {
                var code = getCountryCodeFromListItem(li);
                if (code && topCountries.indexOf(code) !== -1) {
                    topItems.push({ li: li, code: code });
                } else {
                    restItems.push(li);
                }
            });
            
            topItems.sort(function(a, b) {
                return topCountries.indexOf(a.code) - topCountries.indexOf(b.code);
            });
            
            topItems.forEach(function(o) { list.appendChild(o.li); });
            restItems.forEach(function(li) { list.appendChild(li); });
            
            list.setAttribute('data-blz-reordered', '1');
        } finally {
            reorderBlzInProgress = false;
        }
    }
    // ----- OS country list - end here -----
    
    // ===== Footer Country Selector (disclosure) - Top 3 + Separator =====
    var footerTopCountries = ['ch', 'de', 'us'];
    var footerReorderInProgress = false;
    
    function reorderFooterCountryList() {
        if (footerReorderInProgress) return;
        
        var listWraps = document.querySelectorAll('.footer-menu__disclosure .disclosure__list-wrap');
        listWraps.forEach(function(listWrap) {
            var list = listWrap.querySelector('ul.disclosure-list');
            if (!list || list.getAttribute('data-footer-reordered') === '1') return;
            
            var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li.disclosure-list__item'));
            if (items.length === 0) return;
            
            // Check if this is country list (has country_code buttons)
            var hasCountryButtons = list.querySelector('button[name="country_code"]') !== null;
            if (!hasCountryButtons) return;
            
            footerReorderInProgress = true;
            try {
                var topItems = [];
                var restItems = [];
                
                items.forEach(function(li) {
                    var btn = li.querySelector('button[name="country_code"]');
                    var code = btn ? btn.getAttribute('value') || '' : '';
                    code = code.toLowerCase();
                    
                    if (footerTopCountries.indexOf(code) !== -1) {
                        topItems.push({ li: li, code: code });
                    } else {
                        restItems.push(li);
                    }
                });
                
                // Sort top items by predefined order
                topItems.sort(function(a, b) {
                    return footerTopCountries.indexOf(a.code) - footerTopCountries.indexOf(b.code);
                });
                
                // Clear list and rebuild
                list.innerHTML = '';
                
                // Add top countries
                topItems.forEach(function(o) {
                    list.appendChild(o.li);
                });
                
                // Add separator
                var separator = document.createElement('li');
                separator.className = 'disclosure-list__item disclosure-list__separator';
                separator.setAttribute('role', 'separator');
                separator.style.marginBottom = '0';
                separator.style.marginTop = '-8px';
                separator.style.textAlign = 'left';
                separator.style.pointerEvents = 'none';
                separator.innerHTML = '<span style="color:#2e3234;">----</span>';
                list.appendChild(separator);
                
                // Add rest countries
                restItems.forEach(function(li) {
                    list.appendChild(li);
                });
                
                list.setAttribute('data-footer-reordered', '1');
            } finally {
                footerReorderInProgress = false;
            }
        });
    }
    
    // Run when disclosure opens (for both mobile and desktop footers)
    document.addEventListener('click', function(e) {
        var toggle = e.target.closest('.disclosure__toggle');
        if (toggle) {
            setTimeout(reorderFooterCountryList, 50);
            setTimeout(reorderFooterCountryList, 200);
        }
    });
    
    // Also run on initial load for already-open disclosures
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(reorderFooterCountryList, 300);
        });
    } else {
        setTimeout(reorderFooterCountryList, 300);
    }
    // ===== Footer Country Selector end =====
    
    // Update countries without changing language selection
    function updateCountriesPreserveLanguage(langCode) {
        // Force use the provided language code, don't try to detect
        var langToUse = langCode || savedLang || currentLang || 'de';
        savedLang = langToUse;
        currentLang = langToUse;
        
        // Update countries with the preserved language
        updateCountries(langToUse);
        
        // Restore language selection multiple times to ensure it sticks
        setTimeout(function() {
            restoreLanguageSelection(langToUse);
        }, 50);
        
        setTimeout(function() {
            restoreLanguageSelection(langToUse);
        }, 150);
        
        setTimeout(function() {
            restoreLanguageSelection(langToUse);
        }, 300);
    }
    
    // Update everything
    function updateAll(langCode) {
        updateCountries(langCode);
        updateUI(langCode);
        fixLanguageNames();
    }
    
    // Initialize
    function init() {
        var langSelect = document.getElementById('blz_store_selector_selectlanguage');
        var countrySelect = document.getElementById('blz_store_selector_selectcountry');
        
        if (!langSelect || !countrySelect) return false;
        
        // Get current values from window.Shopify (most reliable source)
        var shopifyLang = getShopifyLocale();
        var shopifyCountry = getShopifyCountry();
        
        // Use Shopify values if available, otherwise try to detect from selects
        var detectedLang = shopifyLang || getCurrentLanguageFromSelect();
        var detectedCountry = shopifyCountry;
        
        // Set country first if we have it from Shopify
        if (detectedCountry) {
            savedCountry = detectedCountry;
            setTimeout(function() {
                restoreCountrySelection(detectedCountry);
                updateCountryFlag(detectedCountry);
            }, 100);
            setTimeout(function() {
                updateCountryFlag(detectedCountry);
            }, 300);
        }
        
        // Set and save language
        if (detectedLang) {
            savedLang = detectedLang;
            currentLang = detectedLang;
            setTimeout(function() {
                restoreLanguageSelection(detectedLang);
            }, 150);
        } else if (savedLang) {
            // Restore saved language if available
            restoreLanguageSelection(savedLang);
            detectedLang = savedLang;
        } else {
            // Default to German if nothing detected
            detectedLang = 'de';
            savedLang = 'de';
        }
        
        // Listen for language changes - save the selection
        langSelect.addEventListener('change', function() {
            var selectedOption = langSelect.options[langSelect.selectedIndex];
            if (selectedOption) {
                var lang = detectLangCode(selectedOption.textContent) || detectLangCode(selectedOption.value) || 'de';
                savedLang = lang; // Save user's language selection
                currentLang = lang;
                updateAll(lang);
            }
        });
        
        // Listen for country changes - preserve language selection
        countrySelect.addEventListener('change', function(e) {
            // Save the selected country immediately
            if (countrySelect.value) {
                savedCountry = countrySelect.value;
                updateCountryFlag(countrySelect.value);
            }
            
            // CRITICAL: Get language BEFORE any updates happen
            var langToPreserve = getCurrentLanguageFromSelect() || savedLang || currentLang;
            
            // Force save the language immediately
            savedLang = langToPreserve;
            currentLang = langToPreserve;
            
            // Restore language IMMEDIATELY to prevent reset
            restoreLanguageSelection(langToPreserve);
            
            // Update countries with preserved language, not default
            setTimeout(function() {
                // Restore language again
                restoreLanguageSelection(langToPreserve);
                
                // Then update countries
                updateCountriesPreserveLanguage(langToPreserve);
                
                // Force restore language multiple times to ensure it sticks
                setTimeout(function() {
                    restoreLanguageSelection(langToPreserve);
                    updateUI(langToPreserve);
                }, 100);
                
                setTimeout(function() {
                    restoreLanguageSelection(langToPreserve);
                }, 200);
                
                setTimeout(function() {
                    restoreLanguageSelection(langToPreserve);
                }, 400);
            }, 10);
        }, true); // Use capture phase to run before other handlers
        
        // Initial update with detected/saved language
        updateAll(detectedLang);
        
        reorderBlzOsCountryList();
        
        return true;
    }
    
    // Keep fixing language names and UI every 500ms
    setInterval(function() {
        fixLanguageNames();
        
        var langSelect = document.getElementById('blz_store_selector_selectlanguage');
        var countrySelect = document.getElementById('blz_store_selector_selectcountry');
        
        // Update flag if country is set
        if (countrySelect && countrySelect.value && savedCountry) {
            if (countrySelect.value !== savedCountry) {
                savedCountry = countrySelect.value;
            }
            updateCountryFlag(countrySelect.value || savedCountry);
        }
        
        reorderBlzOsCountryList();
        
        if (langSelect && langSelect.options[langSelect.selectedIndex]) {
            var lang = detectLangCode(langSelect.options[langSelect.selectedIndex].textContent) || currentLang;
            
            // If language was reset to default, restore saved language
            if (savedLang && lang !== savedLang) {
                restoreLanguageSelection(savedLang);
                lang = savedLang;
            }
            
            // Update current language tracking
            if (lang) {
                currentLang = lang;
                if (!savedLang) savedLang = lang;
            }
            
            updateUI(lang);
        } else if (savedLang) {
            // If select exists but no selection, restore saved language
            restoreLanguageSelection(savedLang);
        }
    }, 500);
    
    // Watch for popup opening and restore language/country from Shopify
    function watchForPopup() {
        var overlay = document.querySelector('.blz_overlay_blocker.blz_blk_main_block');
        if (overlay && overlay.offsetParent !== null) { // Check if popup is actually visible
            // Popup is visible, get current values from Shopify
            var shopifyLang = getShopifyLocale();
            var shopifyCountry = getShopifyCountry();
            
            // Update country from Shopify
            if (shopifyCountry) {
                savedCountry = shopifyCountry;
                setTimeout(function() {
                    restoreCountrySelection(shopifyCountry);
                    updateCountryFlag(shopifyCountry);
                }, 100);
                setTimeout(function() {
                    updateCountryFlag(shopifyCountry);
                }, 300);
            }
            
            // Update language from Shopify
            if (shopifyLang) {
                savedLang = shopifyLang;
                currentLang = shopifyLang;
                setTimeout(function() {
                    restoreLanguageSelection(shopifyLang);
                    var langSelect = document.getElementById('blz_store_selector_selectlanguage');
                    if (langSelect) {
                        var currentLangFromSelect = getCurrentLanguageFromSelect();
                        if (!currentLangFromSelect || currentLangFromSelect !== shopifyLang) {
                            // Language was reset or doesn't match, restore it
                            restoreLanguageSelection(shopifyLang);
                            updateAll(shopifyLang);
                        }
                    }
                }, 200);
            } else if (savedLang) {
                // Fallback to saved language if Shopify doesn't have it
                setTimeout(function() {
                    restoreLanguageSelection(savedLang);
                    var langSelect = document.getElementById('blz_store_selector_selectlanguage');
                    if (langSelect) {
                        var currentLangFromSelect = getCurrentLanguageFromSelect();
                        if (currentLangFromSelect && currentLangFromSelect !== savedLang) {
                            // Language was reset, restore it
                            restoreLanguageSelection(savedLang);
                            updateAll(savedLang);
                        }
                    }
                }, 200);
            }
        }
    }
    
    // Try to initialize
    setTimeout(function() {
        if (!init()) setTimeout(init, 1000);
    }, 1000);
    setTimeout(init, 2000);
    setTimeout(init, 3000);
    
    // Watch for language select being reset
    function watchLanguageSelect() {
        var langSelect = document.getElementById('blz_store_selector_selectlanguage');
        if (langSelect && savedLang) {
            var currentLangFromSelect = getCurrentLanguageFromSelect();
            // If language was reset to something other than saved, restore it
            if (currentLangFromSelect && currentLangFromSelect !== savedLang) {
                restoreLanguageSelection(savedLang);
            } else if (!currentLangFromSelect && savedLang) {
                // If no language detected but we have saved, restore it
                restoreLanguageSelection(savedLang);
            }
        }
    }
    
    // Watch for popup visibility changes (do NOT call reorderBlzOsCountryList here - it mutates DOM and causes infinite loop)
    var observer = new MutationObserver(function(mutations) {
        watchForPopup();
        watchLanguageSelect();
    });
    
    // Start observing when DOM is ready
    setTimeout(function() {
        var body = document.body;
        if (body) {
            observer.observe(body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'style', 'selected']
            });
        }
        
        // Also watch the language select directly
        var langSelect = document.getElementById('blz_store_selector_selectlanguage');
        if (langSelect) {
            var langObserver = new MutationObserver(function() {
                watchLanguageSelect();
            });
            langObserver.observe(langSelect, {
                attributes: true,
                attributeFilter: ['selected'],
                childList: true,
                subtree: true
            });
        }
    }, 500);
    
    // Also check language select periodically
    setInterval(watchLanguageSelect, 300);
    
    // Also check periodically
    setInterval(watchForPopup, 1000);
    
    // Listen for popup button clicks to set values immediately
    function setupPopupButtonListener() {
        // Find the country/language selector button
        var geoButton = document.querySelector('.blz-geo_btn, .blz_geo_button, [aria-label*="country"], [aria-label*="Country"]');
        if (geoButton) {
            geoButton.addEventListener('click', function() {
                // When button is clicked, wait for popup to appear then set values
                setTimeout(function() {
                    var shopifyLang = getShopifyLocale();
                    var shopifyCountry = getShopifyCountry();
                    
                    if (shopifyCountry) {
                        savedCountry = shopifyCountry;
                        setTimeout(function() {
                            restoreCountrySelection(shopifyCountry);
                            updateCountryFlag(shopifyCountry);
                        }, 300);
                        setTimeout(function() {
                            updateCountryFlag(shopifyCountry);
                        }, 500);
                    }
                    
                    if (shopifyLang) {
                        savedLang = shopifyLang;
                        currentLang = shopifyLang;
                        setTimeout(function() {
                            restoreLanguageSelection(shopifyLang);
                            updateAll(shopifyLang);
                        }, 400);
                    }
                }, 500);
            });
        }
    }
    
    // Setup button listener when DOM is ready
    setTimeout(setupPopupButtonListener, 1000);
    setTimeout(setupPopupButtonListener, 2000);
    setTimeout(setupPopupButtonListener, 3000);
    
    // Manual function for testing
    window.translateAll = function(lang) {
        savedLang = lang;
        updateAll(lang);
    };
})();